import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";
import UserEntityMemberInvitationsTable from "users/super-users/_views/user-administration/pending-user-entity-member-invitations-table";
import Loader from "_shared/_views/loading/loader";
import { useGetActiveUserInvitationsQuery } from "users/super-users/_api/super-user-api";

const StyledInvitationsContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  position: "relative",
  overflowY: "auto",
  height: "100%",
  width: "100%",
}));

export default function ActiveUserInvitationsPage() {
  const invitationsQuery = useGetActiveUserInvitationsQuery();

  useEffect(() => {
    if (invitationsQuery.error) {
      enqueueSnackbar("Failed to get open invitations", { variant: "error" });
    }
  }, [invitationsQuery.error]);

  return (
    <StyledInvitationsContainer>
      {invitationsQuery.isLoading && <Loader />}
      {invitationsQuery.data && <UserEntityMemberInvitationsTable invitations={invitationsQuery.data} />}
    </StyledInvitationsContainer>
  );
}
